import axios from "../plugins/parseAxios";

export class MessageTemplateApi {
  static createMessageTemplate(formData) {
    return axios.post("functions/createMessageTemplate", formData);
  }
  static removeMessageTemplate(id) {
    return axios.post("functions/removeMessageTemplate", {
      id
    });
  }
  static updateMessageTemplate(formData) {
    return axios.post("functions/updateMessageTemplate", formData);
  }
  static getMessageTemplateByProject(projectId) {
    return axios.post("functions/getMessageTemplateByProject", {
      projectId
    });
  }
}